// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileGifOutlinedSvg from "@fishx/icons-svg/es/asn/FileGifOutlined";
import FishxIcon from '../components/FishxIcon';

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileGifOutlinedSvg
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
export default React.forwardRef(FileGifOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileGifOutlined.js
// module id = 2710
// module chunks = 0